<template>
  <div class="Video" :class="{ Zindex: flag }">
      <div class="video-item" :class="{ opaque: flag }">
        <iframe id="vimeo-player-1" :src="videoUrl" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import { mapState } from 'vuex';

export default {
  name: 'Video',

  computed: {
    ...mapState(['videoUrl']),
  },

  mounted() {
    const iframe = document.querySelector('iframe');
    this.player = new Player(iframe);
    this.player.on('ended', () => {
      this.$router.push('/quiz');
    });
  },

  methods: {
    pauseVideo() {
      if (this.flag === true) {
        this.player.pause();
      } else {
        this.player.play();
      }
    },
  },

  props: {
    flag: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.Video {
  background: black;
  margin: 0 0 90px;
  top: 67px;
  position: relative;
  height: 600px;
  @media (max-width: 767px){
    height: 300px;
  }
  .video-item {
    width: 100%;
    height: 100%;
  }

  .opaque {
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: #171c25;
    opacity: 0.3;
  }
}
.Zindex {
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/modules/Home/components/Video.vue